module.exports = __webpack_public_path__ + "img/skypark-residence.f0fd8f24.png";